export function serialize(record) {
  return JSON.stringify(record);
}

export function deserialize(json) {
  const {
    id,
    parent,
    chapter,
    code,
    description,
    short_description,
    duty,
    free_trade_zone_agreements,
    duty_sng,
    from_date,
    to_date,
    iscode,
    level,
    unit_code,
    unit_name
  } = json;

  return {
    id,
    parentId: parent,
    chapter,
    code,
    description,
    shortDescription: short_description,
    duty,
    free_trade_zone_agreements,
    duty_sng,
    fromDate: from_date,
    toDate: to_date,
    iscode,
    level,
    unitCode: unit_code,
    unitName: unit_name
  };
}



// WEBPACK FOOTER //
// ./src/serializers/TnvedNode.js